import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { appGetLocale, isMobileAspectRatio } from '../helpers/appHelper';
import { Animator, MoveIn, MoveOut, ScrollContainer, ScrollPage, ZoomIn, ZoomOut, batch } from 'react-scroll-motion';
import Footer from '../components/Footer';
import { useLocation, useNavigate } from 'react-router-dom';

const AboutUs = () => {
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';
    const parent = useRef(null);
    const headerHeight = useSelector(state => state.headerHeight);
    const sectorHeight = `calc(100vh - ${headerHeight}px - 1px)`;
    const mobileSectorHeight = `calc((80vh - ${headerHeight}px - 1px))`;
    const isMobile = isMobileAspectRatio();
    const location = useLocation();
    const nav = useNavigate();
    
    useEffect(() => {
        if (location.state?.neededToRefresh === 'Y') {
            nav(location.pathname, { state: { neededToRefresh: 'N' } });
        }
    }, [location, nav]);

    const handleScrollToNextPage = (index) => {
        if (parent.current) {
            const nextPage = parent.current.querySelector('.about_us-sector:nth-child(' + index + ')');
            if (nextPage) {
                nextPage.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    const BrandStory1 = () => {
        return (
            <div className='about_us-brand-story'>
                <div className="abous_us-brand-story-content">
                    {
                        isEng ?
                        <img src='./images/brand_story_desc_en.png' style={{ cursor: 'pointer' }} onClick={() => handleScrollToNextPage(2)} />
                        :
                        <img src='./images/brand_story_desc.png' style={{ cursor: 'pointer' }} onClick={() => handleScrollToNextPage(2)} />
                    }
                </div>
                {!isMobile && <img src='./images/about_us_background1-edit.png' className="about-us-background1-edit" />}
            </div >
        )
    };

    const BrandStory2 = () => {
        return (
            <div className="about_us-brand-story2">
                <img src='./images/about_us_background1.png' className="about-us-background1" />
                <img src='./images/about_us_background2-edit.png' className="about-us-background2-edit" />
                <Animator animation={batch(MoveIn(200, 0), MoveOut(200, 0))} className="about-us-yamazaki-building">
                    <img src='./images/JP_2.png' style={{ width: '100%' }} />
                </Animator>
                <Animator animation={batch(MoveIn(200, 0), MoveOut(-200, 0))} className="about-us-brand-story2-text">
                    {
                        isEng ?
                        <img src='./images/about_us-brand-story2-en.png' style={{ width: "100%" }} onClick={() => handleScrollToNextPage(3)} />
                        :
                        <img src='./images/about_us-brand-story2.png' style={{ width: "100%" }} onClick={() => handleScrollToNextPage(3)} />
                    }
                </Animator>
            </div>
        )
    };

    const BrandStory3 = () => {
        const item1Animation = batch(
            {
                in: {
                    style: {
                        transform: (p) => `rotate(${300 + p * 60}deg)`,
                    },
                }
            },
            {
                in: {
                    style: {
                        transform: (value) => `translate( ${-500 * (1 - value)}px, ${200 * (1 - value)}px)`,
                    },
                }
            }, MoveOut(-100, -100)
        );

        return (
            <div className="about_us-brand-story3">
                <img src='./images/about_us_background2.png' className="about-us-background2" />
                <img src='./images/about_us-HK_Factory-edit.png' className="about-us-background3-edit" />
                <Animator className="about-us-shop1" animation={batch(MoveIn(-500, -300), MoveOut(-500, -300), ZoomOut(1, 1.2))}>
                    <img src='./images/about_us_shop1.png' style={{ width: "20%" }} />
                    <img src='./images/about_us_shop2.png' style={{ width: "20%", marginTop: "2vw" }} />
                </Animator>
                <Animator className="about-us-shop2" animation={batch(MoveIn(300, 300), MoveOut(300, -300), ZoomOut(1, 1.2))}>
                    <img src='./images/about_us_shop3.png' style={{ width: "30%" }} />
                </Animator>
                <Animator className="about-us-item1" animation={item1Animation}>
                    <img src='./images/about_us_item_photo1.png' style={{ width: "50%" }} />
                </Animator>
                <Animator className="about-us-item2" animation={batch(MoveIn(200, -120), MoveOut(200, -200))}>
                    <img src='./images/about_us_item_photo2.png' style={{ width: "25%" }} />
                </Animator>
                <Animator className="about-us-brand-story3-text" animation={batch(MoveIn(0, 200), MoveOut(0, -200))}>
                    {
                        isEng ?
                        <img src='./images/about_us-brand-story3-en.png' style={{ width: "23%", marginRight: "3vw" }} onClick={() => handleScrollToNextPage(4)} />
                        :
                        <img src='./images/about_us-brand-story3.png' style={{ width: "25%" }} onClick={() => handleScrollToNextPage(4)} />
                    }
                </Animator>
            </div>
        )
    };

    const BrandStory4 = () => {
        return (
            <div className="about_us-brand-story4">
                <img src='./images/about_us-HK_Factory.png' className="about-us-hk-factory" />
                <img src='./images/about_us_background2-edit.png' className="about-us-background2-edit" />
                <Animator animation={batch(MoveIn(0, 200), MoveOut(0, 200))} className="about-us-brand-story4-text">
                    {
                        isEng ?
                        <img src='./images/about_us-brand-story4-en.png' style={{ width: "60%" }} />
                        :
                        <img src='./images/about_us-brand-story4.png' style={{ width: "60%" }} />
                    }
                </Animator>
            </div>
        )
    };

    const BrandStory5 = () => {
        const item5Animation = batch(
            MoveIn(50, 100), 
            ZoomIn(1.2, 1), 
            {
                out: {
                    style: {
                        opacity: (value) => value>0.05 ? 0 : 1
                    },
                }
            },
        );

        const item6Animation = batch(
            ZoomIn(1, 1.2),
            {
                in: {
                    style: {
                        transform: (p) => `rotate(${50 - p * 50}deg)`,
                    },
                }
            },
            {
                in: {
                    style: {
                        transform: (value) => `translate( 0px, ${20 * (1 - value)}vh)`,
                    },
                }
            },
            {
                out: {
                    style: {
                        opacity: (value) => value>0.2 ? 0 : 1
                    },
                }
            },
            {
                out: {
                    style: {
                        transform: (p) => `rotate(${p * 70}deg)`,
                    },
                }
            },
            { 
                out: { 
                    style: { 
                        transform: (value) => `translate( ${15 - (15 * (1 - value))}vw, ${20 - (20 * (1 - value))}vh)` 
                    } 
                } 
            },
            ZoomOut(1.2, 1)
        );

        return (
            <div className="about_us-brand-story5">
                <img src='./images/about_us_background2.png' className="about-us-background2" />
                <img src='./images/about_us_background5.png' className="about-us-background5" />
                <Animator animation={batch(MoveIn(-200, 0), MoveOut(0, -200))} className="about-us-brand-story5-text">
                    {
                        isEng ?
                            <img src='./images/about_us-brand-story5-en.png' style={{ width: "60%" }} />
                            :
                            <img src='./images/about_us-brand-story5.png' style={{ width: "60%" }} />
                    }
                </Animator>
                <Animator animation={batch(MoveIn(-200, -100), ZoomIn(1.2, 1), MoveOut(0, -200), ZoomOut(1, 1.5))} className="about-us-item3">
                    <img src='./images/about_us_item_photo3.png' style={{ width: "20%" }} />
                </Animator>
                <Animator animation={batch(MoveIn(300, -100), ZoomIn(1.2, 1), MoveOut(300, -200), ZoomOut(1, 1.5))} className="about-us-item4">
                    <img src='./images/about_us_item_photo4.png' style={{ width: isEng?"22%":"28%" }} />
                </Animator>
                <Animator animation={item6Animation} className="about-us-item6">
                    <img src='./images/about_us_item_photo6.png' style={{ width: "40%" }} />
                </Animator>
                <Animator animation={item5Animation} className="about-us-item5">
                    <img src='./images/about_us_item_photo5.png' style={{ width: "26%" }} />
                </Animator>
            </div>
        )
    };

    const BrandStory6 = () => {
        const item5AnimationSecond = batch(
            {
                in: {
                    style: {
                        opacity: (value) => value>=0.05 ? 1 : 0
                    },
                }
            },
            {
                in: {
                    style: {
                        transform: (value) => `translate( ${11.5 * (1 - value)}vw, ${-40  * (1 - value)}vh)`,
                    },
                }
            },
            MoveOut(150,100)
        );

        const item6AnimationSecond = batch(
            ZoomIn(1.2, 1),
            {
                in: {
                    style: {
                        opacity: (value) => value>0.2 ? 1 : 0
                    },
                }
            },
            {
                in: {
                    style: {
                        transform: (p) => `rotate(${290 + p * 70}deg)`,
                    },
                }
            },
            {
                in: {
                    style: {
                        transform: (value) => `translate( ${5 * (1 - value)}vw, ${-20 * (1 - value)}vh)`,
                    },
                }
            },
            MoveOut(-100, 100),
            ZoomOut(1, 1.1)
        );
        
        return (
            <div className="about_us-brand-story6">
                <img src='./images/about_us_background5-edit.png' className="about-us-background5-edit" />
                <img src='./images/about_us_background5-edit.png' className="about-us-background5-edit double" />
                <img src='./images/about_us_background5-edit.png' className="about-us-background5-edit triple" />
                <Animator animation={batch(MoveIn(-100,200),MoveOut(-100,-100))} className="about-us-brand-story6-text">
                    {
                        isEng ?
                        <img src='./images/about_us-brand-story6-en.png' style={{ width: "60%" }} />
                        :
                        <img src='./images/about_us-brand-story6.png' style={{ width: "50%" }} />
                    }
                </Animator>
                <Animator animation={item5AnimationSecond} className="about-us-item5-second">
                    <img src='./images/about_us_item_photo5.png' style={{ width: "26%" }} />
                </Animator>
                <Animator animation={item6AnimationSecond} className="about-us-item6-second">
                    <img src='./images/about_us_item_photo6-second.png' style={{ width: "30%" }} />
                </Animator>
                <Animator animation={batch(MoveIn(200,0), MoveOut(200,100), ZoomOut(1,0.8))} className="about-us-item7">
                    <img src='./images/about_us_item_photo7.png' style={{ width: "40%" }} />
                </Animator>
                <Animator animation={batch(MoveIn(-100,0), MoveOut(0,100))} className="about-us-item8">
                    <img src='./images/about_us_item_photo8.png' style={{ width: "30%" }} />
                </Animator>
            </div>
        )
    };

    const BrandStory1_mobile = () => {
        return (
            <div className='about_us-brand-story'>
                <div className="abous_us-brand-story-content">
                    {
                        isEng ?
                        <img src='./images/mobile_brand_story_desc_en.png' />
                        :
                        <img src='./images/mobile_brand_story_desc.png' style={{ transform: `scale(0.4)` }} />
                    }
                </div>
            </div >
        )
    };

    const BrandStory2_mobile = () => {
        return (
            <div className="about_us-brand-story2">
                <img src='./images/mobile_about-us_background2.png' className="about-us-background1"/>
                <div className="about-us-yamazaki-building">
                    <img src='./images/mobile_JP_2.png' style={{ maxHeight: '80vh' }} />
                </div>
                <Animator animation={MoveIn(0, 200)} className="about-us-brand-story2-text">
                    {
                        isEng ?
                        <img src='./images/about_us-brand-story2-en.png' style={{ width: "100%" }} />
                        :
                        <img src='./images/about_us-brand-story2.png' style={{ width: "100%" }} />
                    }
                </Animator>
            </div>
        )
    };

    const BrandStory3_mobile = () => {
        return (
            <div className="about_us-brand-story3">
                <img src='./images/mobile_about-us_background3.png' className="about-us-background2"/>
                <div className="about-us-item1" style={{top: isEng? '20%':'25%'}}>
                    <img src='./images/mobile-about_us_item_photo1.png' style={{ width: "80%" }} />
                </div>
                <div className="about-us-item2">
                    <img src='./images/mobile-about_us_item_photo2.png' style={{ width: "50%" }} />
                </div>
                <div className="about-us-brand-story3-text" >
                    {
                        isEng ?
                        <img src='./images/mobile-about_us-brand-story3-en.png' style={{ maxHeight: "90%", maxWidth: "100%" }} />
                        :
                        <img src='./images/mobile-about_us-brand-story3.png' style={{ maxHeight: "90%", maxWidth: "100%" }} />
                    }
                </div>
                <img src='./images/mobile_about-us_background3.png' className="about-us-background2-edit"/>
            </div>
        )
    };

    const BrandStory4_mobile = () => {
        return (
            <div className="about_us-brand-story4">
                {
                    isEng ?
                    <img src='./images/mobile-about_us_background4-en.png' className="about-us-hk-factory" />
                    :
                    <img src='./images/mobile-about_us_background4.png' className="about-us-hk-factory" />
                }
                <div className='about_us-brand-story4-background' />
            </div>
        )
    };

    const BrandStory5_mobile = () => {
        return (
            <div className="about_us-brand-story5">
                {
                    isEng?
                    <img src='./images/mobile-about_us_background5-en.png' className="about-us-background5" />
                    :
                    <img src='./images/mobile-about_us_background5.png' className="about-us-background5" />
                }
            </div>
        )
    };

    return (
        isMobile?
        <div className='about_us' ref={parent} style={{ height: sectorHeight }}>
            <ScrollContainer scrollParent={parent.current} style={{ height: mobileSectorHeight }} simpleHeight={headerHeight}>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight, overflow: 'unset' }}>
                    <BrandStory1_mobile />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: mobileSectorHeight, overflow: 'unset' }}>
                    <BrandStory2_mobile />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: mobileSectorHeight, overflow: 'unset' }}>
                    <BrandStory3_mobile />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: mobileSectorHeight, overflow: 'unset' }}>
                    <BrandStory4_mobile />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height:'auto', overflow: 'unset', marginTop: '-30%' }}>
                    <BrandStory5_mobile />
                </ScrollPage>
                <Footer />
            </ScrollContainer>
        </div>
        :
        <div className='about_us' ref={parent} style={{ height: sectorHeight }}>
            <ScrollContainer scrollParent={parent.current} style={{ height: sectorHeight }} simpleHeight={headerHeight}>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight }}>
                    <BrandStory1 />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight }}>
                    <BrandStory2 />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight }}>
                    <BrandStory3 />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight }}>
                    <BrandStory4 />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight, overflow: 'unset' }}>
                    <BrandStory5 />
                </ScrollPage>
                <ScrollPage className='about_us-sector' style={{ height: sectorHeight, overflow: 'unset' }}>
                    <BrandStory6 />
                </ScrollPage>
                <Footer />
            </ScrollContainer>
        </div>
    );
};

export default AboutUs;